import { render } from "./Vue.vue?vue&type=template&id=662282be"
const script = {}

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_c888307087c990cfda5c0d18ef320e2e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/icons/Vue.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "662282be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('662282be', __exports__)) {
    api.reload('662282be', __exports__)
  }
  
  module.hot.accept("./Vue.vue?vue&type=template&id=662282be", () => {
    api.rerender('662282be', render)
  })

}


export default __exports__